import { render, staticRenderFns } from "./export.vue?vue&type=template&id=1ca8c2a8&scoped=true"
import script from "./export.vue?vue&type=script&lang=js"
export * from "./export.vue?vue&type=script&lang=js"
import style0 from "./export.vue?vue&type=style&index=0&id=1ca8c2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8c2a8",
  null
  
)

export default component.exports